/**
 * Formats a number with thousands separators
 * @param {number|string} value - The number to format
 * @param {string} separator - Thousands separator (default is comma)
 * @param {number} decimals - Fixed number of decimal places (optional)
 * @returns {string} - Formatted number
 *
 * @example
 * formatNumberWithSeparator(3000000) // "3,000,000"
 * formatNumberWithSeparator(1234.56) // "1,234.56"
 * formatNumberWithSeparator(570, ',', 2) // "570.00"
 * formatNumberWithSeparator(1000, ' ') // "1 000"
 */
export const formatNumberWithSeparator = (value, separator = ',', decimals = null) => {
    if (value === null || value === undefined || value === '' || isNaN(value)) {
        return value;
    }

    let num = Number(value);

    if (decimals !== null && decimals !== undefined) {
        num = Number(num.toFixed(decimals));
    }

    const parts = num.toFixed(decimals !== null && decimals !== undefined ? decimals : undefined).split('.');

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);

    return parts.join('.');
};
